/**
 * @file: useInspectionSiteGrid.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useMemo, useState } from 'react';
import * as InspectionSiteGrid from './InspectionSiteGrid';

export const useInspectionSiteGrid = ({
  flowId,
  ...props
}: {
  flowId: string;
  keyword?: string;
}) => {
  const { detail, inventoryQuery } = useTaskContext();
  const flow = detail.inspection.flows.find(x => x.id === flowId);
  const [activeSectionForHiddenSites, setActiveSectionForHiddenSites] =
    useState<InspectionSiteGrid.GroupSection>();
  const keyword = useMemo(
    () => props.keyword?.trim().toLowerCase(),
    [props.keyword],
  );
  const sections = useMemo(
    () =>
      flow?.template
        ? InspectionSiteGrid.buildGroupSectionsFromTemplate(
            flowId,
            inventoryQuery,
            flow.template,
            detail.inspection.sites,
            detail.inspection.customIssues,
            keyword,
          )
        : [],
    [
      flowId,
      flow?.template,
      inventoryQuery,
      detail.inspection.sites,
      detail.inspection.customIssues,
      keyword,
    ],
  );
  const scrollerItems = useMemo(() => sections.map(x => x.title), [sections]);
  return {
    activeSectionForHiddenSites,
    setActiveSectionForHiddenSites,
    scrollerItems,
    sections,
  };
};
